<template>
  <div class="fixed top-0 bottom-0 right-0 left-0 bg-black z-50">
    <ul ref="slider">
      <li v-for="(item, count) in images" class="w-full flex items-center justify-center" @click="flkty.next()" :key="count">
        <div class="flex items-center" v-if="item" v-html="item" />
        <div class="w-full m-32 p-32 border-white border" v-else>No Image</div>
      </li>
    </ul>
  </div>
</template>

<script>
import Flickity from 'flickity'
export default {

  name: 'Gallery',

  data () {
    return {
      flkty: null
    }
  },

  props: ['images'],

  methods: {
    start () {
      const el = this.$refs.slider
      this.flkty = new Flickity(el, {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        wrapAround: true,
        percentPosition: true,
        setGallerySize: true,
      })
    }
  },

  mounted () {
    if (!this.images.length || !this.$refs.slider) return
    this.$nextTick(() => {
      this.start()
    })
  }
}
</script>
<style lang="stylus" scoped>
  li
    width: 100vw
    height: 70vh
    margin-top: 15vh
    color: white

    div
      width: 100%

    div, img
      height: 70vh
      width: auto
</style>
